import AVTR1 from "../../assets/avatar1.jpg";
import AVTR2 from "../../assets/avatar2.jpg";
import AVTR3 from "../../assets/avatar3.jpg";
import AVTR4 from "../../assets/avatar4.jpg";

export const data = [
  {
    avatar: AVTR1,
    name: "Tina Snow",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus reiciendis delectus pariatur laboriosam dolorem molestiae est asperiores voluptates numquam autem!",
  },
  {
    avatar: AVTR2,
    name: "Shatta Wale",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus reiciendis delectus pariatur laboriosam dolorem molestiae est asperiores voluptates numquam autem!",
  },
  {
    avatar: AVTR3,
    name: "Kwame Despite",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus reiciendis delectus pariatur laboriosam dolorem molestiae est asperiores voluptates numquam autem!",
  },
  {
    avatar: AVTR4,
    name: "Nana Ama McBrown",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus reiciendis delectus pariatur laboriosam dolorem molestiae est asperiores voluptates numquam autem!",
  },
];
